import axios from "axios";
import Cookies from "js-cookie";
import liveAuth from "src/helper/liveAuth";
import System from "src/helper/system";

const METHOD = {
    GET: "get",
    POST: "post",
    PUT: "put",
    DELETE: "delete",
};

// CHECK BELOW FOR SAMPLE DATA TO BE PASSED
class Api {
    constructor() { }

    // URL FOR API
    // REFER SAMPLE JSON AT BOTTOM FOR DATA VALUES

    get(url, data) {
        return new Promise((resolve, reject) => {
            this.api(METHOD.GET, url, data)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    console.error(error);
                    reject(error);
                });
        });
    }

    post(url, data) {
        return new Promise((resolve, reject) => {
            this.api(METHOD.POST, url, data)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    console.error(error);
                    reject(error);
                });
        });
    }

    put(url, data) {
        return new Promise((resolve, reject) => {
            this.api(METHOD.PUT, url, data)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    console.error(error);
                    reject(error);
                });
        });
    }

    delete(url, data) {
        return new Promise((resolve, reject) => {
            this.api(METHOD.DELETE, url, data)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    console.error(error);
                    reject(error);
                });
        });
    }

    api(method, url, data) {
        return new Promise((resolve, reject) => {
            const contentType = data?.isMultipart ? "multipart/form-data" : '';
            let axiosConfig = {
                method: method,
                url: url
            };

            if (System.getTierParam().length > 0) {
                axiosConfig.url = url + (url.includes('?') ? '&' : '?') + System.getTierParam();
            }

            axiosConfig.headers = this.getCommonHeader(method, contentType);

            if (data) {
                if (data.params) axiosConfig.params = data.params;
                if (data.data && data.data.responseType && data.data.responseType === "blob")
                    axiosConfig.responseType = "blob";
                if (data.data) axiosConfig.data = data.data;
            }

            axios(axiosConfig)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    console.log("API err ",error?.response?.data?.ErrorCode, error?.response?.data?.Message)
                    console.error("TCL: Api -> api -> error", error);
                    reject(error);
                });
        });
    }

    getCommonHeader(method, contentType = '') {
        const reqType = {
            GET: 'GET, OPTIONS',
            POST: 'POST, OPTIONS',
            PUT: 'PUT, OPTIONS',
            DELETE: 'DELETE, OPTIONS'
        }

        return {
            'accept': 'text/plain',
            'Content-Type': contentType !== '' ? contentType : 'application/json-patch+json',
            'avUserInfo': encodeURI(liveAuth.getAvUserInfoString()),
            'Authorization': 'Bearer ' + Cookies.get('apt_am'),
            // 'Authorization': 'Bearer ' + document.getElementById("randomVal")?.value,
            'Ocp-Apim-Subscription-Key': process.env.REACT_APP_OCP_SUBSCRIPTION_KEY,
            'Access-Control-Allow-Methods': reqType[method.toUpperCase()],
            'speedboat': System.avUserInfoData.speedBoatAbbr
        }
    }


}


export default Api;